import { call, put, select, takeLatest, takeLeading } from "redux-saga/effects";
import { API_URL } from "utils/constants";
import { getPaginationMeta } from "utils/helpers/pagination";
import { request } from "utils/request";

import { RegistrationForm, RegistrationListResponse } from "../types";
import {
  selectRegistrationForm,
  selectRegistrationPage,
  selectRegistrationPerPage,
} from "./selector";
import { registrationActions } from "./slice";

let isFetchingList = false;

export function* handleGetRegistrationList() {
  if (isFetchingList) return;
  isFetchingList = true;

  try {
    const page: number = yield select(selectRegistrationPage);
    const perPage: number = yield select(selectRegistrationPerPage);

    const response: RegistrationListResponse = yield call(
      request,
      `${API_URL}/registration-instructions?page=${page}&perPage=${perPage}`,
      { method: "GET" }
    );

    const data = response?.data || [];
    const meta = getPaginationMeta(page, perPage, data, response?.meta);
    const payload = { data, meta };

    if (page === 1) {
      yield put(registrationActions.getRegistrationListSuccess(payload));
    } else {
      yield put(registrationActions.getNextPageItemsSuccess(payload));
    }
  } catch (error) {
    const message = (error as Error).message;
    const page: number = yield select(selectRegistrationPage);

    if (page === 1) {
      yield put(registrationActions.getRegistrationListError(message));
    } else {
      yield put(registrationActions.getNextPageItemsError(message));
    }
  } finally {
    isFetchingList = false;
  }
}

export function* handleAddRegistration() {
  const form: RegistrationForm = yield select(selectRegistrationForm);

  try {
    yield call(request, `${API_URL}/registration-instructions`, {
      method: "POST",
      body: JSON.stringify({
        manufecturerID: 1,
        modelID: 593,
        year: 2024,
        cabinType: form.driverCabinType.trim(),
        tireSize: form.tire.trim(),
        hangerType: form.suspensionType.trim(),
        weight: form.weight.trim(),
        wealBase: Number(form.axlesMeasure),
        lowerRange: Number(form.lowerLimit),
        upperRange: Number(form.upperLimit),
        axleLoad: Number(form.frontLoad),
        backAxleDistance: Number(form.rearAxlesMeasure),
        remarks: form.notes.trim(),
        needEngPlan: "N",
        sideWallTypeID: Number(form.bodyType),
        structureType: Number(form.dhType),
      }),
    });

    yield put(registrationActions.addRegistrationSuccess());
    yield put(registrationActions.getRegistrationList());
  } catch (error) {
    yield put(
      registrationActions.addRegistrationError((error as Error).message)
    );
  }
}

export function* registrationSaga() {
  yield takeLeading(
    registrationActions.getRegistrationList.type,
    handleGetRegistrationList
  );
  yield takeLeading(
    registrationActions.getNextPageItems.type,
    handleGetRegistrationList
  );
  yield takeLatest(
    registrationActions.addRegistration.type,
    handleAddRegistration
  );
}

export default registrationSaga;
